var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferFriend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_498",
    "data-name": "Group 498",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 333.829,
    height: 358.55,
    viewBox: "0 0 333.829 358.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 333.829,
    height: 358.55,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 29.183,
    height: 41.802,
    transform: "translate(-2 5)",
    fill: "#f3a76f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 4.38,
    height: 36.17,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(0 1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5565",
    "data-name": "Path 5565",
    d: "M306.658,352.9c-16.284-10.66-20.418-31.067-20.238-49.5.03-3.078-.391-6.313,1.024-9.045s4.829-4.66,7.651-3.431c2.34,1.018,3.414,3.651,4.763,5.818a18.156,18.156,0,0,0,7.475,6.714c2.01.969,4.479,1.53,6.412.417,2.652-1.528,2.879-5.2,2.785-8.259q-.265-8.548-.528-17.1a28.133,28.133,0,0,1,.713-9.107c.892-2.925,2.955-5.672,5.883-6.559s6.616.706,7.311,3.685a27.812,27.812,0,0,1,.181,3.806c.117,1.267.752,2.658,1.983,2.983s2.464-.569,3.369-1.485c3.123-3.165,5.2-7.194,7.126-11.2s3.8-8.1,6.62-11.538,6.769-6.2,11.2-6.557,9.227,2.237,10.454,6.51-1.212,8.72-3.9,12.276a68.723,68.723,0,0,1-14.069,13.894,5.645,5.645,0,0,0-2.348,2.614c-.622,2.054,1.385,4.033,3.44,4.655,2.33.7,4.83.407,7.253.63s5.067,1.211,6.038,3.444c1.345,3.1-1.224,6.436-3.778,8.644a59.448,59.448,0,0,1-17.293,10.41c-2.259.879-4.64,1.657-6.439,3.282s-2.842,4.4-1.679,6.527,4.032,2.751,6.409,2.258,4.484-1.824,6.738-2.726c4.22-1.688,9.727-1.53,12.543,2.037a9.577,9.577,0,0,1,1.254,8.533A22.255,22.255,0,0,1,360.5,333.2a59.556,59.556,0,0,1-25.01,18.255c-9.8,3.617-18.927,4.751-28.832,1.442",
    transform: "translate(-37.342 -31.621)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5566",
    "data-name": "Path 5566",
    d: "M369.284,245.33s-.095.105-.3.294l-.9.827c-.8.725-1.97,1.8-3.442,3.216A114.805,114.805,0,0,0,353.1,262.55c-2.24,2.889-4.559,6.156-6.985,9.706s-4.979,7.373-7.519,11.486A137.4,137.4,0,0,0,331.263,297c-1.137,2.368-2.144,4.841-3.169,7.362s-2.055,5.076-3.1,7.662a277.732,277.732,0,0,0-10.319,29.7,134.874,134.874,0,0,0-4.54,25.228,98.523,98.523,0,0,0,.15,17.286c.215,2.032.416,3.609.59,4.671.076.517.135.919.178,1.212.038.274.045.416.045.416s-.514-2.21-.993-6.279a94.855,94.855,0,0,1-.3-17.33,132.949,132.949,0,0,1,4.455-25.317,272.438,272.438,0,0,1,10.3-29.762l3.107-7.665c1.024-2.515,2.039-5.005,3.186-7.383a136.826,136.826,0,0,1,7.377-13.287c2.555-4.114,5.13-7.927,7.565-11.477s4.782-6.806,7.043-9.69a109.762,109.762,0,0,1,11.677-12.812c1.493-1.4,2.686-2.452,3.5-3.156l.934-.793c.212-.177.329-.258.329-.258",
    transform: "translate(-40.362 -31.989)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5567",
    "data-name": "Path 5567",
    d: "M333.378,299.436a7.374,7.374,0,0,1-.314-1.3c-.177-.843-.4-2.069-.646-3.586-.5-3.036-1.061-7.251-1.664-11.9s-1.232-8.847-1.8-11.864c-.279-1.51-.52-2.73-.7-3.57a7.319,7.319,0,0,1-.225-1.318,7.511,7.511,0,0,1,.4,1.277c.233.83.524,2.042.844,3.548.653,3.009,1.336,7.213,1.939,11.868.591,4.61,1.126,8.781,1.528,11.912.2,1.457.37,2.67.5,3.605a7.352,7.352,0,0,1,.137,1.331",
    transform: "translate(-42.771 -34.67)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5568",
    "data-name": "Path 5568",
    d: "M373.842,294.917a1.4,1.4,0,0,1-.409.077l-1.177.129c-1.022.107-2.5.259-4.319.507-3.641.466-8.648,1.292-14.13,2.447s-10.4,2.435-13.922,3.459c-1.766.5-3.184.944-4.166,1.248l-1.133.343a.209.209,0,1,1-.03-.088l1.106-.425c.964-.357,2.371-.85,4.13-1.391,3.51-1.106,8.425-2.43,13.921-3.6s10.525-1.935,14.187-2.319c1.829-.206,3.316-.31,4.343-.362l1.185-.043a1.413,1.413,0,0,1,.415.017",
    transform: "translate(-43.574 -38.452)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5569",
    "data-name": "Path 5569",
    d: "M312.263,347.731a2.377,2.377,0,0,1-.274-.477c-.185-.367-.42-.834-.709-1.41-.61-1.226-1.451-3.022-2.461-5.254-2.024-4.462-4.629-10.709-7.416-17.641s-5.344-13.194-7.288-17.684c-.964-2.2-1.752-4-2.324-5.31l-.629-1.446a2.375,2.375,0,0,1-.19-.517,2.5,2.5,0,0,1,.274.478c.184.365.419.833.708,1.41.611,1.226,1.451,3.022,2.459,5.254,2.024,4.462,4.63,10.709,7.418,17.644s5.342,13.19,7.287,17.682c.964,2.2,1.752,4,2.324,5.31l.629,1.446a2.529,2.529,0,0,1,.191.517",
    transform: "translate(-37.94 -38.855)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5570",
    "data-name": "Path 5570",
    d: "M367.987,334.37a2.644,2.644,0,0,1-.524.217l-1.528.535-5.632,1.933c-4.752,1.637-11.288,3.979-18.5,6.585s-13.776,4.9-18.558,6.461c-2.391.781-4.332,1.394-5.679,1.793l-1.555.454a2.56,2.56,0,0,1-.552.127,2.677,2.677,0,0,1,.523-.217l1.528-.535,5.631-1.932c4.752-1.637,11.288-3.981,18.506-6.586s13.774-4.9,18.555-6.46c2.391-.78,4.332-1.394,5.68-1.793l1.555-.454a2.549,2.549,0,0,1,.552-.127",
    transform: "translate(-41.132 -43.598)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5571",
    "data-name": "Path 5571",
    d: "M61.175,216.059,75.92,259.148h66.768l-.492-2.219-27-.835L102.76,216.036Z",
    transform: "translate(-7.977 -28.169)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5572",
    "data-name": "Path 5572",
    d: "M94.433,238.945c.441,1.765-.316,3.495-1.689,3.862s-2.844-.765-3.285-2.531.316-3.494,1.689-3.862,2.844.766,3.285,2.531",
    transform: "translate(-11.648 -30.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5573",
    "data-name": "Path 5573",
    d: "M231.767,323.223l22.187,76.159h2.666L239.6,322.961Z",
    transform: "translate(-30.22 -42.111)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5574",
    "data-name": "Path 5574",
    d: "M182.327,323.7,165.15,399.447H168.2l22.991-75.772Z",
    transform: "translate(-21.534 -42.204)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5575",
    "data-name": "Path 5575",
    d: "M208.015,321.692l2.628,77.5h3.6l1.582-77.2Z",
    transform: "translate(-27.123 -41.945)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5576",
    "data-name": "Path 5576",
    d: "M183.406,358.727l51.516-1.614.341,5.333-55.723,2.137Z",
    transform: "translate(-23.41 -46.564)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M184.75,323.675l-.79,3.919h8.525l1.064-3.919Z",
    transform: "translate(-23.987 -42.204)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5578",
    "data-name": "Path 5578",
    d: "M207.99,321.939l.184,5.429h7.559l.093-4.484Z",
    transform: "translate(-27.12 -41.978)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5579",
    "data-name": "Path 5579",
    d: "M208.477,358.177l.189,5.547-4,.154-1.3-5.54Z",
    transform: "translate(-26.517 -46.703)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5580",
    "data-name": "Path 5580",
    d: "M216.249,357.841l-.116,5.636,3.126-.119.721-5.517Z",
    transform: "translate(-28.182 -46.659)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5581",
    "data-name": "Path 5581",
    d: "M231.381,321.939l1.141,3.919h7.7l-.848-3.808Z",
    transform: "translate(-30.17 -41.978)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5582",
    "data-name": "Path 5582",
    d: "M165.08,301.186c7.326-3.591,36.933-1.656,36.933-1.656s-8.36-103.781,2.45-104.611,35.291-8.613,39.707,7.08c4.639,16.492-1.633,104.665-7.826,103.811-14.126-1.949-57.689,3.1-70.8.008-3.38-.8-.459-4.632-.459-4.632",
    transform: "translate(-21.372 -25.069)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5583",
    "data-name": "Path 5583",
    d: "M244.853,205.521c.046-.025.254.258.61.829a12.393,12.393,0,0,1,.605,1.085c.237.433.468.951.724,1.537a36.618,36.618,0,0,1,2.552,10.492,131.68,131.68,0,0,1,.435,15.956c-.1,6-.467,12.584-1,19.478s-1.208,13.449-1.832,19.4-1.219,11.331-2.057,15.805a67.678,67.678,0,0,1-2.7,10.426,15.169,15.169,0,0,1-1.6,3.612,27.727,27.727,0,0,1,1.035-3.791,88.029,88.029,0,0,0,2.205-10.426c.7-4.451,1.187-9.8,1.725-15.763s1.165-12.507,1.711-19.384.941-13.428,1.119-19.394a152,152,0,0,0-.1-15.819,41.164,41.164,0,0,0-2.036-10.382c-.832-2.365-1.5-3.6-1.389-3.664",
    transform: "translate(-31.368 -26.798)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5584",
    "data-name": "Path 5584",
    d: "M234.578,318.316c-.086.431-6.818-.627-15.166-1.3-8.351-.7-15.163-.747-15.179-1.186-.022-.4,6.847-1.03,15.3-.326,8.455.679,15.131,2.42,15.043,2.808",
    transform: "translate(-26.63 -41.098)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 236.717,
    height: 7.754,
    transform: "translate(17.746 230.341)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5585",
    "data-name": "Path 5585",
    d: "M38.92,273.8,20.407,392.873l9.256.17L61.432,273.8Z",
    transform: "translate(-2.661 -35.7)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5586",
    "data-name": "Path 5586",
    d: "M269.445,271.785l10.818,120.457h-8.62L248.294,276.774l-1.219-8.575Z",
    transform: "translate(-32.216 -34.97)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5587",
    "data-name": "Path 5587",
    d: "M247.872,273.8l.86,5.358,21.342-.794-.409-4.564Z",
    transform: "translate(-32.32 -35.7)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5588",
    "data-name": "Path 5588",
    d: "M41.565,273.8l-.872,5.486,22.057-.612,1.328-4.874Z",
    transform: "translate(-5.306 -35.7)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5589",
    "data-name": "Path 5589",
    d: "M30.313,262.819v-9.288l4.679-1.032-4.679-2.891v-8.784h49.91v5.263l2.819-.011c-.462.523.909,1.153.307,1.374-1.01.373-3.438.955-3.438.955l.624,3.659-2.807.629,3.744,2.629.624,6.916L30.313,263.3",
    transform: "translate(-3.953 -31.401)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5590",
    "data-name": "Path 5590",
    d: "M25.068,262.819v-9.288l4.679-1.032-4.679-2.891v-8.784h49.91v5.263l2.818-.011c-.462.523.91,1.153.307,1.374-1.01.373-3.438.955-3.438.955l.624,3.659-2.808.629,3.744,2.629.624,6.916L25.068,263.3",
    transform: "translate(-3.269 -31.401)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5591",
    "data-name": "Path 5591",
    d: "M289.78,250.572a5.974,5.974,0,0,0-4.009-1.154c.006-.772-.029-1.249-.029-1.249H263.881s-.687,14.435,10.366,14.945c4.947.228,7.779-1.989,9.4-4.779a11.034,11.034,0,0,0,2.48.3,5.724,5.724,0,0,0,3.443-.973,4.337,4.337,0,0,0,1.644-3.7,4.23,4.23,0,0,0-1.431-3.393m-1.5,5.364c-.933.7-2.605.592-3.694.4a19.241,19.241,0,0,0,1.064-4.747,4.164,4.164,0,0,1,2.738.634,2.14,2.14,0,0,1,.668,1.747,2.287,2.287,0,0,1-.776,1.971",
    transform: "translate(-34.406 -32.359)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5592",
    "data-name": "Path 5592",
    d: "M104.953,127.889,94.029,117.342H36.413v-34.5l81.276-1.705V116.63H103.423Zm-67.67-11.416h57.1l9.373,9.049-1.328-9.761H116.82V82.026L37.283,83.695Z",
    transform: "translate(-4.748 -10.579)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 27.159,
    height: 3.186,
    transform: "translate(42.381 80.951)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 60.521,
    height: 3.186,
    transform: "translate(42.381 88.228)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 60.521,
    height: 3.186,
    transform: "translate(42.381 94.547)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5593",
    "data-name": "Path 5593",
    d: "M81.584,3.307l1.653,44.828h67.681l62.214-20.853V0Z",
    transform: "translate(-10.638 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5594",
    "data-name": "Path 5594",
    d: "M161.7,24.659l.55,36.761h57.48s5.555,25.558,5.578,24.158,7.026-24.508,7.026-24.508l74.222-.7V22.908Z",
    transform: "translate(-21.084 -2.987)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 113.736,
    height: 3.601,
    transform: "translate(156.178 34.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 113.736,
    height: 3.602,
    transform: "translate(156.178 42.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    "data-name": "Path 5595",
    d: "M290.437,411.012c0,.125-65.022.227-145.211.227-80.217,0-145.226-.1-145.226-.227s65.009-.227,145.226-.227c80.189,0,145.211.1,145.211.227",
    transform: "translate(0 -53.562)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    "data-name": "Path 5596",
    d: "M81.285,277.868c-4.926.792-7.128,6.846-6.7,11.816s2.474,9.83,1.928,14.789c-.695,6.3-5.453,11.621-6.008,17.932-.654,7.443,4.609,14.045,6.181,21.351.764,3.553.657,7.313,1.981,10.7a13.375,13.375,0,0,0,25.83-4.613c.11-5.716-3.418-11.1-2.989-16.8.317-4.213,2.786-8.206,2.258-12.4-.63-4.987-5.252-8.529-6.882-13.285s-.064-10-.627-15c-1.01-8.965-5.981-15.214-14.974-14.495",
    transform: "translate(-9.186 -36.224)",
    fill: "#f3a76f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M53.966,327.791c-.838,8.307,2.835,18.079,7.106,25.252a39.6,39.6,0,0,0,18.6,16.141c.869.363,1.95.668,2.681.076a2.679,2.679,0,0,0,.678-2.131,40.785,40.785,0,0,0-29.062-39.337",
    transform: "translate(-7.021 -42.741)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(49.079 280.391)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5598",
    "data-name": "Path 5598",
    d: "M53.966,327.791c-.838,8.307,2.835,18.079,7.106,25.252a39.6,39.6,0,0,0,18.6,16.141c.869.363,1.95.668,2.681.076a2.679,2.679,0,0,0,.678-2.131,40.785,40.785,0,0,0-29.062-39.337",
    transform: "translate(-55.846 -322.791)",
    fill: "#f3a76f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5599",
    "data-name": "Path 5599",
    d: "M91.757,388.8a2.221,2.221,0,0,1-.237-.463c-.157-.358-.353-.809-.593-1.361-.5-1.186-1.245-2.894-2.2-4.99a177.591,177.591,0,0,0-8.247-15.966,177.517,177.517,0,0,0-9.866-15.024c-1.359-1.857-2.481-3.345-3.27-4.362l-.895-1.184a2.2,2.2,0,0,1-.287-.433,2.155,2.155,0,0,1,.361.373l.964,1.13c.834.984,2,2.443,3.394,4.278a151.658,151.658,0,0,1,10,14.985,151.844,151.844,0,0,1,8.145,16.069c.913,2.117,1.614,3.848,2.061,5.058l.511,1.394a2.144,2.144,0,0,1,.148.5",
    transform: "translate(-8.627 -44.986)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5600",
    "data-name": "Path 5600",
    d: "M89.443,304.3a5.039,5.039,0,0,1,.09.8q.061.845.165,2.288c.13,2.031.315,4.9.542,8.417.449,7.106,1.079,16.925,1.841,27.763s1.515,20.651,2.066,27.753c.27,3.517.488,6.379.644,8.409q.1,1.441.156,2.288a5.061,5.061,0,0,1,.023.8,4.993,4.993,0,0,1-.117-.792q-.09-.844-.244-2.28l-.792-8.4c-.637-7.1-1.441-16.9-2.2-27.747s-1.34-20.664-1.7-27.779c-.164-3.525-.3-6.393-.392-8.426q-.048-1.445-.077-2.292a5.078,5.078,0,0,1,.005-.8",
    transform: "translate(-11.661 -39.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5601",
    "data-name": "Path 5601",
    d: "M80.659,381.74h20.8v15.272a9.986,9.986,0,0,1-19.958.534Z",
    transform: "translate(-10.517 -49.775)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5602",
    "data-name": "Path 5602",
    d: "M328.009,111.987A31.891,31.891,0,0,1,270.1,124.31l-15.114,2.344,10.235-14.228a31.9,31.9,0,1,1,62.785-.438",
    transform: "translate(-33.248 -9.731)",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5603",
    "data-name": "Path 5603",
    d: "M309.69,120.845c2.58.078,4.5-3.211,4.656-8.373.267-8.761-5.79-15.386-14.588-15.654-8.835-.268-15.573,5.967-15.838,14.692-.255,8.361,5.885,14.662,14.466,14.923a14.464,14.464,0,0,0,6.668-1.544l.51,1.18a15.852,15.852,0,0,1-7.219,1.71c-9.307-.283-15.974-7.181-15.7-16.306.288-9.488,7.589-16.253,17.15-15.963,9.415.287,16.076,7.439,15.784,17-.18,5.926-2.587,9.673-6.076,9.567a3.606,3.606,0,0,1-3.484-3.891l.057-1.89a8.515,8.515,0,0,1-8.113,4.738,8.9,8.9,0,0,1-8.771-9.508c.162-5.308,4.026-9.157,9.226-9a8.363,8.363,0,0,1,7.706,5.073l.142-4.689,1.454.044-.451,14.832c-.057,1.891,1.037,3.016,2.419,3.058m-18.967-9.31a7.621,7.621,0,1,0,7.833-7.513,7.443,7.443,0,0,0-7.833,7.513",
    transform: "translate(-36.853 -12.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5604",
    "data-name": "Path 5604",
    d: "M236.985,137.672c-1.551-.472-4.332,7.887-4.776,5.744s4.588-9.828,2.946-10.256c-2.14-.556-4.891,8.249-5.179,8.978-.279.706-1.349.337-1.054-.306.424-.925,4.638-10.749,2.541-11.315-1.163-.314-1.532,1.825-1.532,1.825s-3.266,9.481-4.247,9.181c-1-.305.735-5.936,1.452-7.794.709-1.837.123-2.92-.95-2.558-.733.247-3.065,5.884-3.732,7.738s-2.405,6.97-3.6,3.751-3.326-5.245-4.284-5.391a1.075,1.075,0,0,0-.756,1.887,12.518,12.518,0,0,1,1.8,2.957,8.2,8.2,0,0,1,.761,2.672,28.337,28.337,0,0,1,.137,5.6l.023.523-10.341,25.6-11.486-25.176c-3.681-12.227-18.871-12.73-18.871-12.73l-15.058-1.629c-5.444-2.091-11.524-1.754-14.909.2a17.428,17.428,0,0,0-8.238,11.7c-3.465,17.063-15.55,78.161-16.548,104.92h.05a83.5,83.5,0,0,0-1.381,8.813c-.295,4.639.121,4.671.667,4.613,1.466-.156.828-8.14,1.96-6.5s-.354,9.856,1.172,9.631c1.989-.294,1.167-8.64,1.15-9.352-.017-.691,1.01-.761.991-.117-.026.924-.07,10.643,1.887,10.373,1.084-.15.635-2.071.635-2.071s-.63-9.1.3-9.194,1.491,5.231,1.55,7.04c.057,1.789.932,2.487,1.7,1.8.525-.466.477-6.013.378-7.8s-.459-6.688,1.684-4.418,4.645,3.211,5.5,2.993a.977.977,0,0,0-.037-1.847,11.411,11.411,0,0,1-2.568-1.849,7.341,7.341,0,0,1-1.553-1.92c-.13-.237-.241-.45-.357-.67.329-5.086,3.322-48.788,11.021-78.741l1.451-3.733c1.507,6.075.609,18.544-2.583,23.928-5.285,8.918-4.867,30.842-4.867,30.842l48.6,1.843s-.378-8.064-.808-18.354l-1.076-30.281.125-5.806.225-.606c2.343,3.747,5.282,8.56,8.916,14.69,12.075,20.374,22.265-3.878,22.265-3.878l10.327-29.208a124.656,124.656,0,0,0,7.273-11.388c2.289-4.571,1.883-4.783,1.3-4.958",
    transform: "translate(-15.602 -17.014)",
    fill: "#e5baab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5605",
    "data-name": "Path 5605",
    d: "M166.378,405.588v-7.86l-14.723-.094-.122,11.5.912.064c4.061.251,20.667.993,23.387.187,3.035-.9-9.455-3.8-9.455-3.8",
    transform: "translate(-19.759 -51.848)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5606",
    "data-name": "Path 5606",
    d: "M176.19,410.281c0,.138-5.507.251-12.3.251s-12.3-.113-12.3-.251,5.506-.252,12.3-.252,12.3.113,12.3.252",
    transform: "translate(-19.766 -53.464)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5607",
    "data-name": "Path 5607",
    d: "M168.895,408.409c-.121-.066-.015-.489.3-.9s.7-.622.792-.523-.1.451-.393.83-.579.661-.7.592",
    transform: "translate(-22.016 -53.064)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5608",
    "data-name": "Path 5608",
    d: "M169.973,408.963c-.128-.05-.061-.523.23-1.014s.67-.781.776-.693-.075.493-.342.949-.533.811-.664.758",
    transform: "translate(-22.155 -53.1)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5609",
    "data-name": "Path 5609",
    d: "M156.055,409.843c-.057.042-.278-.165-.6-.515a9.443,9.443,0,0,0-1.3-1.239,3.514,3.514,0,0,0-1.586-.655c-.442-.057-.732,0-.757-.07-.025-.055.245-.251.766-.286a2.967,2.967,0,0,1,1.872.6,5.181,5.181,0,0,1,1.29,1.429c.256.413.372.69.317.731",
    transform: "translate(-19.794 -53.078)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5610",
    "data-name": "Path 5610",
    d: "M168.74,406.916c.07.118-.186.4-.605.545s-.794.09-.813-.046.277-.3.646-.43.7-.191.772-.07",
    transform: "translate(-21.817 -53.049)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5611",
    "data-name": "Path 5611",
    d: "M168.424,406.017c.012.138-.38.257-.877.263s-.892-.1-.884-.241.4-.257.877-.263.87.1.884.24",
    transform: "translate(-21.731 -52.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5612",
    "data-name": "Path 5612",
    d: "M184.181,401.785l2.327-7.507-14.034-4.449-3.521,10.947.852.332c3.8,1.442,19.446,7.066,22.284,7.1,3.165.04-7.908-6.425-7.908-6.425",
    transform: "translate(-22.03 -50.83)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5613",
    "data-name": "Path 5613",
    d: "M192.662,409.2c-.041.132-5.334-1.391-11.821-3.4s-11.715-3.75-11.674-3.882,5.333,1.39,11.822,3.4,11.715,3.749,11.673,3.882",
    transform: "translate(-22.058 -52.405)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5614",
    "data-name": "Path 5614",
    d: "M186.2,405.264c-.1-.1.131-.471.556-.77s.85-.387.911-.263-.233.4-.622.675-.748.46-.845.358",
    transform: "translate(-24.276 -52.701)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5615",
    "data-name": "Path 5615",
    d: "M187.054,406.111c-.108-.086.1-.517.52-.9s.87-.547.946-.432-.217.448-.608.8-.749.617-.858.528",
    transform: "translate(-24.386 -52.774)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5616",
    "data-name": "Path 5616",
    d: "M173.559,402.813c-.067.023-.217-.24-.421-.67a9.425,9.425,0,0,0-.878-1.568,3.5,3.5,0,0,0-1.321-1.1c-.405-.186-.7-.213-.7-.29-.008-.059.31-.167.817-.047a2.974,2.974,0,0,1,1.609,1.131,5.192,5.192,0,0,1,.809,1.747c.123.47.151.77.087.792",
    transform: "translate(-22.197 -52.037)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5617",
    "data-name": "Path 5617",
    d: "M186.529,403.8c.032.133-.3.325-.74.341s-.784-.149-.763-.285.353-.2.744-.218.726.025.758.163",
    transform: "translate(-24.125 -52.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5618",
    "data-name": "Path 5618",
    d: "M186.505,402.818c-.029.136-.438.132-.915-.008s-.822-.361-.772-.49.459-.127.915.008.8.355.772.49",
    transform: "translate(-24.098 -52.446)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5619",
    "data-name": "Path 5619",
    d: "M181.064,134.686c-.226-1.633.652-8.43.652-8.43s6.246-.46,6.822-6.622.656-20.41.656-20.41l-11.161-5.908-12.776,9.049-3.333,7.145,4.247,15.684-.016,8.1Z",
    transform: "translate(-21.113 -12.167)",
    fill: "#e5baab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5620",
    "data-name": "Path 5620",
    d: "M191.92,110.884c.05-.043-.025-.245-.272-.478a2.1,2.1,0,0,0-2.481-.23c-.286.183-.4.366-.356.419.085.117.738-.284,1.586-.2a2.387,2.387,0,0,1,.318.05.78.78,0,0,0-.43.665.791.791,0,1,0,1.533-.23c.045.016.083.022.1,0",
    transform: "translate(-24.618 -14.326)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5621",
    "data-name": "Path 5621",
    d: "M181.075,110.535c.05-.043-.025-.246-.272-.478a2.1,2.1,0,0,0-2.481-.231c-.285.183-.4.367-.356.419.084.117.737-.284,1.587-.2a2.441,2.441,0,0,1,.41.074.771.771,0,0,0-.321.244.79.79,0,1,0,1.275.935.775.775,0,0,0,.082-.759.086.086,0,0,0,.076-.005",
    transform: "translate(-23.204 -14.281)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5622",
    "data-name": "Path 5622",
    d: "M184.8,117.95a5.691,5.691,0,0,1,1.4-.13c.217,0,.43-.03.481-.186a1.2,1.2,0,0,0-.1-.69l-.526-1.782a33.325,33.325,0,0,1-1.153-4.636,5.619,5.619,0,0,1,.5,1.31c.269.822.617,1.964.982,3.231l.5,1.79a1.376,1.376,0,0,1,.056.893.529.529,0,0,1-.372.294,1.445,1.445,0,0,1-.37.023,5.641,5.641,0,0,1-1.4-.115",
    transform: "translate(-24.097 -14.411)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5623",
    "data-name": "Path 5623",
    d: "M181.531,119.885c.685.257,2.331,1.492,4.068,1.548a2.356,2.356,0,0,1-2.846.71c-1.791-.825-1.222-2.258-1.222-2.258",
    transform: "translate(-23.659 -15.632)",
    fill: "#efede9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5624",
    "data-name": "Path 5624",
    d: "M183.47,130.741a15.426,15.426,0,0,1-8.091-3.025s1.708,4.592,7.907,4.535Z",
    transform: "translate(-22.868 -16.653)",
    fill: "#d78776"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M192.066,88.959a3.763,3.763,0,0,0-3.47-.922,23.506,23.506,0,0,0-3.546,1.206,5.435,5.435,0,0,1-3.667.219c-1.607-.608-2.493-2.32-3.878-3.335a5.12,5.12,0,0,0-7.66,1.947c-.691,1.465-.837,3.433-2.295,4.143-1.171.57-2.536-.026-3.783-.4a5.93,5.93,0,0,0-3.555-.123A3.131,3.131,0,0,0,158,94.279c-.075,1.1.587,2.144.551,3.247-.054,1.677-1.631,2.851-3.075,3.706s-3.074,1.872-3.36,3.526a4.438,4.438,0,0,0,1.632,3.751,40.361,40.361,0,0,1,3.185,2.821,3.677,3.677,0,0,1,.8,3.93c-.334.63-.944,1.127-1.087,1.825-.237,1.167.909,2.114,1.939,2.71a9.185,9.185,0,0,0,3.485,1.358,4.362,4.362,0,0,0,1.485-.095c.846,2.474,1.365,4.565,1.365,4.565,1.032,1.68,1.036-3.8,1.036-3.8s.5-5.294-.339-7.3c0,0-3.136,1.214-4.179-4.478a2.581,2.581,0,0,1,5.043-1.05l2.684.095S168.849,98.1,175.035,100c10.923,3.347,16.78-.173,17.538-9.04l-.035.009a2.3,2.3,0,0,0-.472-2.01",
    transform: "translate(-19.829 -11.102)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M166.994,116.33c-.024-.016-.088.07-.238.15a.918.918,0,0,1-.684.056,2.27,2.27,0,0,1-1.172-1.97,3.046,3.046,0,0,1,.177-1.329,1.06,1.06,0,0,1,.647-.744.466.466,0,0,1,.556.218c.08.143.053.25.081.257s.108-.1.052-.31a.587.587,0,0,0-.227-.317.7.7,0,0,0-.515-.1,1.294,1.294,0,0,0-.908.874,3.114,3.114,0,0,0-.229,1.485,2.382,2.382,0,0,0,1.475,2.19.982.982,0,0,0,.829-.189c.156-.14.176-.259.157-.268",
    transform: "translate(-21.452 -14.633)",
    fill: "#d78776"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M190.974,227.625l-19.317-1.484-29.279-2.372,3.273,157.252,25.419-.333s-.022-1.749-.059-4.819l14.9,4.078s14.524-49.057,19.476-69.194c4.13-16.795-14.413-83.128-14.413-83.128M170.735,351.416c-.388-36.295-.911-94.329-.381-101.879,0,0,14.236,50.652,14.37,54.939.083,2.608-7.8,27.688-13.989,46.94",
    transform: "translate(-18.565 -29.177)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(152.17 311.644)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M174.987,368.967l.276,24.453,4.1,1.123-.994-36.171Z",
    transform: "translate(-174.987 -358.372)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5629",
    "data-name": "Path 5629",
    d: "M174.183,250.024c-.08-.045.584-1.07,1.153-2.918a24.942,24.942,0,0,0,.915-7.47c-.031-2.964-.219-5.666-.152-7.626.023-.98.083-1.772.153-2.317a2.63,2.63,0,0,1,.167-.838c.077.008-.013,1.211.036,3.155.024,1.944.267,4.627.3,7.624a22.2,22.2,0,0,1-1.082,7.584,11.621,11.621,0,0,1-.985,2.116,2.462,2.462,0,0,1-.505.69",
    transform: "translate(-22.711 -29.84)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5630",
    "data-name": "Path 5630",
    d: "M170.944,230.271c-.017-.023.095-.154.376-.267a1.824,1.824,0,0,1,1.265.005,1.78,1.78,0,0,1,1.2,1.468,1.927,1.927,0,0,1-3.36,1.567,1.77,1.77,0,0,1-.344-1.865,1.81,1.81,0,0,1,.819-.964c.269-.139.441-.137.447-.11a2.379,2.379,0,0,0-.929,1.187,1.418,1.418,0,0,0,.341,1.43,1.478,1.478,0,0,0,2.564-1.2,1.429,1.429,0,0,0-.872-1.186,2.423,2.423,0,0,0-1.508-.069",
    transform: "translate(-22.16 -29.976)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5631",
    "data-name": "Path 5631",
    d: "M198.929,236.308a3.61,3.61,0,0,1-1.8.7,6.769,6.769,0,0,1-7.587-4.361,3.584,3.584,0,0,1-.3-1.908c.085-.012.159.723.632,1.774a6.946,6.946,0,0,0,7.208,4.142c1.145-.12,1.819-.426,1.851-.345",
    transform: "translate(-24.67 -30.086)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5632",
    "data-name": "Path 5632",
    d: "M153.389,226.282a1.69,1.69,0,0,1,.248.664,7.3,7.3,0,0,1,.2,1.923,8.379,8.379,0,0,1-8.24,8.273,7.26,7.26,0,0,1-1.923-.194,1.692,1.692,0,0,1-.665-.245,21.817,21.817,0,0,0,2.57.083,8.423,8.423,0,0,0,7.9-7.935,22.016,22.016,0,0,0-.094-2.57",
    transform: "translate(-18.647 -29.505)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5633",
    "data-name": "Path 5633",
    d: "M171.722,397.31c0,.139-5.686.251-12.7.251s-12.7-.112-12.7-.251,5.684-.251,12.7-.251,12.7.112,12.7.251",
    transform: "translate(-19.08 -51.773)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5634",
    "data-name": "Path 5634",
    d: "M149.963,377c-.139,0-.534-31.012-.882-69.263s-.517-69.271-.378-69.272.534,31.006.882,69.269S150.1,377,149.963,377",
    transform: "translate(-19.383 -31.093)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5635",
    "data-name": "Path 5635",
    d: "M175.871,361.039a1.366,1.366,0,0,1,.065-.292c.061-.217.14-.494.239-.843.231-.77.556-1.851.968-3.225.871-2.829,2.115-6.863,3.647-11.835,1.56-5,3.413-10.941,5.471-17.533,1.035-3.3,2.121-6.76,3.247-10.347q.845-2.692,1.721-5.473c.272-.917.628-1.879.837-2.779a13.211,13.211,0,0,0-.371-2.846c-.827-3.887-1.884-7.642-2.888-11.264s-2.034-7.1-3.017-10.418c-1.967-6.627-3.787-12.582-5.323-17.58-1.532-4.972-2.775-9.007-3.647-11.835l-.979-3.222c-.1-.348-.182-.625-.243-.842a1.248,1.248,0,0,1-.067-.291,1.4,1.4,0,0,1,.116.277l.291.826c.256.763.614,1.831,1.07,3.193.909,2.817,2.2,6.835,3.8,11.788,1.579,4.986,3.435,10.931,5.427,17.554.995,3.311,2.024,6.793,3.047,10.415s2.071,7.378,2.906,11.3c.1.491.2.981.27,1.479a7.285,7.285,0,0,1,.1.752,3.183,3.183,0,0,1,.01.8c-.236,1.006-.574,1.891-.853,2.832l-1.73,5.472-3.275,10.342c-2.1,6.582-3.985,12.512-5.575,17.505l-3.8,11.789c-.451,1.363-.805,2.434-1.058,3.2l-.287.827a1.317,1.317,0,0,1-.114.277",
    transform: "translate(-22.887 -32.651)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5636",
    "data-name": "Path 5636",
    d: "M175.278,390.85a14.28,14.28,0,0,1,2.326.741c1.654.579,3.631,1.271,5.816,2.033l5.819,2.029a13.683,13.683,0,0,1,2.38.94,12.28,12.28,0,0,1-2.49-.6c-1.517-.44-3.6-1.1-5.875-1.893s-4.315-1.574-5.776-2.174a9.09,9.09,0,0,1-2.2-1.075",
    transform: "translate(-22.854 -50.962)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5637",
    "data-name": "Path 5637",
    d: "M159.649,307.525a1.33,1.33,0,0,1,.381-.307,4.2,4.2,0,0,1,1.3-.536,4.407,4.407,0,0,1,2.231.054,4.584,4.584,0,0,1,2.412,1.711,5.814,5.814,0,0,1,.956,3.448c0,1.287-.082,2.627-.127,4.052a29.188,29.188,0,0,1-.361,4.489,6.216,6.216,0,0,1-.907,2.27,3.758,3.758,0,0,1-2.053,1.516,4.913,4.913,0,0,1-4.645-1.354,7.465,7.465,0,0,1-1.917-4.121,18.84,18.84,0,0,1,.572-7.581,10.332,10.332,0,0,1,1.091-2.731,3.5,3.5,0,0,1,1.687-1.459,2.413,2.413,0,0,1,1.4-.13.982.982,0,0,1,.453.188,2.611,2.611,0,0,0-1.782.123,3.356,3.356,0,0,0-1.522,1.426,10.449,10.449,0,0,0-.988,2.675,19.01,19.01,0,0,0-.457,7.413,7.042,7.042,0,0,0,1.805,3.845,4.443,4.443,0,0,0,4.158,1.223,3.27,3.27,0,0,0,1.782-1.317,5.776,5.776,0,0,0,.836-2.089,29.743,29.743,0,0,0,.38-4.405c.058-1.419.159-2.781.173-4.028a5.5,5.5,0,0,0-.829-3.247,4.257,4.257,0,0,0-4.313-1.778,6.237,6.237,0,0,0-1.719.65",
    transform: "translate(-20.439 -39.973)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5638",
    "data-name": "Path 5638",
    d: "M200.607,316.022a23.265,23.265,0,0,1-4.788.611,23.249,23.249,0,0,1-4.825.11,23.27,23.27,0,0,1,4.788-.611,23.322,23.322,0,0,1,4.825-.11",
    transform: "translate(-24.904 -41.196)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    "data-name": "Path 5639",
    d: "M199.067,319a27.945,27.945,0,0,1-7.2-2.079,27.945,27.945,0,0,1,7.2,2.079",
    transform: "translate(-25.018 -41.319)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5640",
    "data-name": "Path 5640",
    d: "M212.383,310.144a1.043,1.043,0,0,1,.393.208,2.766,2.766,0,0,1,.829.976,9.692,9.692,0,0,1,.673,4.6,17.26,17.26,0,0,1-1.219,6.794,9.747,9.747,0,0,1-2.378,3.371,4.9,4.9,0,0,1-1.923,1.147,2.427,2.427,0,0,1-1.212.037,1.988,1.988,0,0,1-1.049-.677,4.691,4.691,0,0,1-.828-2.157,18.426,18.426,0,0,1-.283-2.155,19.163,19.163,0,0,1,.172-4.1,18.335,18.335,0,0,1,2.311-6.507,4.879,4.879,0,0,1,1.883-1.92,2.46,2.46,0,0,1,2.026-.1,1.822,1.822,0,0,1,.976.834.94.94,0,0,1,.114.432c-.024.007-.055-.145-.2-.381a1.8,1.8,0,0,0-.954-.7,2.278,2.278,0,0,0-1.83.166,4.663,4.663,0,0,0-1.706,1.853,18.537,18.537,0,0,0-2.158,6.393,19.189,19.189,0,0,0-.14,3.993,18.562,18.562,0,0,0,.284,2.095,4.254,4.254,0,0,0,.724,1.931,1.581,1.581,0,0,0,1.74.479,4.431,4.431,0,0,0,1.726-1.033,9.383,9.383,0,0,0,2.283-3.191,17.447,17.447,0,0,0,1.287-6.613,10.087,10.087,0,0,0-.492-4.5,3.627,3.627,0,0,0-1.047-1.271",
    transform: "translate(-26.775 -40.354)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5641",
    "data-name": "Path 5641",
    d: "M230.175,127.508l5.8,25.164,13.571-2.937L244.8,123.918Z",
    transform: "translate(-30.013 -16.158)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5642",
    "data-name": "Path 5642",
    d: "M232.023,129.089l4.441,20.145,11.775-2.9-4.209-20.238Z",
    transform: "translate(-30.253 -16.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5643",
    "data-name": "Path 5643",
    d: "M245.51,152.837a1.249,1.249,0,1,1-1.249-1.248,1.25,1.25,0,0,1,1.249,1.248",
    transform: "translate(-31.686 -19.766)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 5.515,
    height: 0.079,
    transform: "translate(204.819 111.132) rotate(-12.671)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 10.634,
    height: 8.488,
    transform: "translate(202.778 113.724) rotate(-12.665)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5644",
    "data-name": "Path 5644",
    d: "M235.644,141.01l.786,2.947,10.181-2.325-.72-3.209Z",
    transform: "translate(-30.726 -18.049)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5645",
    "data-name": "Path 5645",
    d: "M236.942,145.756l.93,4.479,10.063-2.515-.965-4.273Z",
    transform: "translate(-30.895 -18.704)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5650",
    "data-name": "Path 5650",
    d: "M199.858,184.754l2.525-3.284c-1.21-.049-2.5-.1-3.846-.158Z",
    transform: "translate(-25.887 -23.641)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5646",
    "data-name": "Path 5646",
    d: "M150.852,179.115c-.272,1.515-.684,3.814-1.167,6.512,5.939.248,13.082.564,20.77.921,8.116.377,15.621.743,21.745,1.057l-.063-6.58c-6.059-.252-13.428-.578-21.382-.947-7.32-.339-14.142-.67-19.9-.963",
    transform: "translate(-19.517 -23.355)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5647",
    "data-name": "Path 5647",
    d: "M140.939,146.457a49.179,49.179,0,0,0-2.995,6.568c6.478.225,18.5.733,32.275,1.373,12.25.568,23.122,1.113,29.929,1.49a56.98,56.98,0,0,0-3.183-6.807c-6.764-.269-16.116-.674-26.446-1.154-12.049-.558-22.755-1.094-29.581-1.471",
    transform: "translate(-17.987 -19.097)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5648",
    "data-name": "Path 5648",
    d: "M183.777,139.824a9.738,9.738,0,0,1-1.495,1.541c4.643.22,9,.434,12.911.63a46.689,46.689,0,0,0-11.416-2.171",
    transform: "translate(-23.768 -18.232)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5649",
    "data-name": "Path 5649",
    d: "M160.706,226.889l33.3,5.265-.037-3.77c-6.463-.264-14.756-.628-23.8-1.047-3.27-.152-6.44-.3-9.462-.448",
    transform: "translate(-20.954 -29.584)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5651",
    "data-name": "Path 5651",
    d: "M144.828,210.959c-.53,2.392-1.057,4.679-1.491,6.538,6.62.267,15.383.65,25,1.095,8.82.41,16.918.806,23.307,1.137l-.063-6.6c-6.333-.261-14.292-.61-22.943-1.011-9.05-.421-17.344-.827-23.806-1.164",
    transform: "translate(-18.69 -27.507)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5652",
    "data-name": "Path 5652",
    d: "M143.092,218.9c-.566,2.413-.958,4.017-.958,4.017l12.2,2.267c4.172.184,8.7.387,13.441.607,9.032.419,17.315.825,23.771,1.161l-.055-5.8c-6.4-.263-14.5-.618-23.333-1.028-9.647-.449-18.436-.881-25.06-1.229",
    transform: "translate(-18.533 -28.543)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5653",
    "data-name": "Path 5653",
    d: "M146.524,203.007c-.411,2.084-.892,4.341-1.374,6.53,6.454.263,14.725.626,23.744,1.044,8.64.4,16.59.79,22.915,1.117l-.063-6.591c-6.267-.259-14.079-.6-22.552-1-8.53-.4-16.384-.78-22.67-1.1",
    transform: "translate(-18.926 -26.47)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5654",
    "data-name": "Path 5654",
    d: "M135.087,162.185c-.733,2.7-1.25,5.078-1.576,6.736,4.908.127,18.934.705,35.483,1.474,12.509.58,23.573,1.135,30.347,1.514l3.515-4.572s-.229-.773-.631-2.017c-6.3-.214-18.683-.735-32.93-1.4-15.3-.71-28.441-1.383-34.208-1.739",
    transform: "translate(-17.409 -21.147)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5655",
    "data-name": "Path 5655",
    d: "M133.415,170.109c-.277,1.422-.407,2.274-.407,2.274l16.016,3.63s-.1.55-.27,1.505c5.752.243,12.555.544,19.851.883,9.867.458,18.834.9,25.509,1.252l4.942-6.426c-6.8-.252-17.769-.721-30.151-1.3-16.575-.77-30.612-1.494-35.49-1.822",
    transform: "translate(-17.343 -22.181)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5656",
    "data-name": "Path 5656",
    d: "M149.426,187.08c-.361,2.022-.758,4.246-1.163,6.52,6.114.254,13.6.584,21.684.96,8.287.383,15.942.757,22.135,1.076l-.063-6.584c-6.132-.254-13.646-.585-21.772-.963-7.711-.357-14.873-.705-20.821-1.01",
    transform: "translate(-19.332 -24.394)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5657",
    "data-name": "Path 5657",
    d: "M137.516,154.294c-.848,2.279-1.557,4.562-2.131,6.662,5.8.181,18.913.728,34.177,1.437,14.176.657,26.507,1.284,32.828,1.656-.559-1.717-1.416-4.216-2.453-6.833-6.8-.253-17.74-.721-30.075-1.293-13.832-.642-25.894-1.252-32.345-1.628",
    transform: "translate(-17.653 -20.119)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5658",
    "data-name": "Path 5658",
    d: "M148,195.044c-.24,1.351-.483,2.714-.72,4.058-.138.778-.294,1.609-.463,2.471,6.279.259,14.113.6,22.615,1,8.462.394,16.264.775,22.526,1.1l-.063-6.587c-6.2-.257-13.865-.594-22.163-.979-8.111-.377-15.61-.743-21.732-1.057",
    transform: "translate(-19.144 -25.432)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5659",
    "data-name": "Path 5659",
    d: "M167.461,140.365a19.847,19.847,0,0,1-3.427-2.914s-8.467-3.718-15.085-.124a12.858,12.858,0,0,0-2.811,2.117c5.7.228,13.1.547,21.324.922",
    transform: "translate(-19.055 -17.702)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5660",
    "data-name": "Path 5660",
    d: "M145.207,140.394a24.755,24.755,0,0,0-3.626,4.971c6.838.259,17.477.714,29.436,1.27,10.214.474,19.466.93,26.207,1.289a12.563,12.563,0,0,0-2.839-3.571,15.1,15.1,0,0,0-3.228-1.793c-4.4-.185-9.423-.406-14.812-.65-2.945,1.961-6.137,1.04-8.61-.4-8.734-.41-16.589-.8-22.527-1.116",
    transform: "translate(-18.461 -18.306)",
    fill: "#8fbfe2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5661",
    "data-name": "Path 5661",
    d: "M141.556,146.11c-.057.1-.111.2-.168.3,6.826.376,17.531.912,29.581,1.471,10.33.48,19.683.885,26.446,1.153-.071-.124-.143-.245-.216-.367-6.74-.358-15.992-.815-26.207-1.289-11.96-.556-22.6-1.01-29.436-1.27",
    transform: "translate(-18.436 -19.051)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5662",
    "data-name": "Path 5662",
    d: "M195.1,142.226c-3.913-.2-8.268-.41-12.911-.63a7.4,7.4,0,0,1-.631.47c5.39.245,10.41.466,14.813.651q-.622-.262-1.27-.49",
    transform: "translate(-23.673 -18.463)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5663",
    "data-name": "Path 5663",
    d: "M146.087,140c-.114.11-.223.231-.336.346,5.939.316,13.794.705,22.527,1.117q-.451-.262-.868-.541c-8.224-.375-15.625-.694-21.324-.922",
    transform: "translate(-19.004 -18.254)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5664",
    "data-name": "Path 5664",
    d: "M137.93,154.009c-.031.083-.063.165-.094.248,6.451.376,18.513.986,32.345,1.628,12.335.572,23.271,1.041,30.074,1.294-.04-.1-.08-.2-.121-.306-6.807-.377-17.679-.923-29.929-1.491-13.774-.639-25.8-1.147-32.275-1.373",
    transform: "translate(-17.972 -20.081)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5665",
    "data-name": "Path 5665",
    d: "M135.377,161.956c-.019.068-.036.132-.054.2,5.767.357,18.906,1.03,34.207,1.739,14.248.661,26.631,1.183,32.93,1.4-.025-.078-.051-.161-.079-.242-6.32-.372-18.651-1-32.828-1.657-15.263-.708-28.379-1.255-34.177-1.436",
    transform: "translate(-17.645 -21.117)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5666",
    "data-name": "Path 5666",
    d: "M133.506,169.931c-.01.052-.021.1-.03.155,4.878.328,18.915,1.052,35.49,1.821,12.382.576,23.353,1.044,30.151,1.3l.219-.284c-6.774-.379-17.837-.935-30.347-1.515-16.549-.768-30.575-1.347-35.483-1.473",
    transform: "translate(-17.404 -22.157)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5667",
    "data-name": "Path 5667",
    d: "M151.1,178.628c-.023.133-.05.274-.076.423,5.761.292,12.582.624,19.9.964,7.954.369,15.323.695,21.383.947v-.079l.03.08c1.35.057,2.636.11,3.846.157l.274-.357c-6.675-.351-15.642-.794-25.509-1.251-7.3-.339-14.1-.641-19.851-.884",
    transform: "translate(-19.693 -23.291)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5668",
    "data-name": "Path 5668",
    d: "M149.674,186.6c-.024.137-.05.275-.074.415,5.947.3,13.11.652,20.82,1.01,8.126.377,15.642.708,21.773.963h.008l0-.41h-.008c-6.126-.314-13.63-.68-21.745-1.057-7.687-.357-14.831-.673-20.771-.921",
    transform: "translate(-19.506 -24.331)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5669",
    "data-name": "Path 5669",
    d: "M148.251,194.578c-.023.135-.048.27-.072.406,6.122.314,13.622.679,21.732,1.057,8.3.385,15.963.722,22.163.979h.016l0-.406h-.015c-6.194-.318-13.848-.692-22.136-1.076-8.087-.376-15.569-.706-21.684-.96",
    transform: "translate(-19.321 -25.371)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5670",
    "data-name": "Path 5670",
    d: "M146.807,202.551c-.025.131-.052.264-.078.4,6.286.324,14.141.709,22.67,1.1,8.473.394,16.285.737,22.553,1h.023l0-.4h-.023c-6.262-.323-14.064-.7-22.526-1.1-8.5-.394-16.336-.738-22.615-1",
    transform: "translate(-19.132 -26.411)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5671",
    "data-name": "Path 5671",
    d: "M145.136,210.516c-.029.129-.057.257-.085.384,6.462.337,14.756.744,23.806,1.164,8.651.4,16.61.751,22.944,1.011h.031l0-.4-.031,0c-6.326-.326-14.276-.715-22.916-1.117-9.018-.418-17.289-.78-23.744-1.044",
    transform: "translate(-18.913 -27.449)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5672",
    "data-name": "Path 5672",
    d: "M143.323,218.476l-.087.37c6.625.348,15.414.78,25.06,1.229,8.829.409,16.938.765,23.333,1.027l.039,0,0-.393-.038,0c-6.388-.331-14.488-.728-23.306-1.137-9.614-.446-18.377-.828-25-1.1",
    transform: "translate(-18.677 -28.487)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5673",
    "data-name": "Path 5673",
    d: "M156.158,226.127l3.427.637.528.026c3.022.146,6.192.3,9.462.447,9.043.42,17.335.784,23.8,1.047l.047,0,0-.388-.045,0c-6.457-.336-14.74-.741-23.772-1.161-4.739-.22-9.269-.423-13.441-.607",
    transform: "translate(-20.361 -29.485)",
    fill: "#8fbfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5674",
    "data-name": "Path 5674",
    d: "M198.463,185.247c-.138.014-.738-5.039-1.339-11.283s-.977-11.32-.839-11.333.738,5.039,1.34,11.285.977,11.317.838,11.331",
    transform: "translate(-25.59 -21.205)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5675",
    "data-name": "Path 5675",
    d: "M197.826,159.806c.115.078-.261.832-.839,1.684s-1.139,1.481-1.255,1.4.261-.832.839-1.685,1.139-1.48,1.255-1.4",
    transform: "translate(-25.519 -20.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5676",
    "data-name": "Path 5676",
    d: "M184.921,190.972c.065.123-6.026,3.465-13.6,7.466s-13.773,7.145-13.838,7.021,6.025-3.465,13.6-7.467,13.772-7.144,13.837-7.02",
    transform: "translate(-20.534 -24.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5677",
    "data-name": "Path 5677",
    d: "M187.751,197.86a18.788,18.788,0,0,1-2.892.622l-7,1.317-6.985,1.418a18.6,18.6,0,0,1-2.913.515,15.916,15.916,0,0,1,2.833-.861c1.769-.458,4.23-1.03,6.967-1.566s5.232-.934,7.043-1.175a15.95,15.95,0,0,1,2.949-.27",
    transform: "translate(-21.9 -25.796)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5678",
    "data-name": "Path 5678",
    d: "M152.081,167.265a9.161,9.161,0,0,1,.038,2.245c-.055,1.384-.2,3.293-.473,5.389s-.621,3.98-.922,5.332a9.189,9.189,0,0,1-.611,2.161,10.912,10.912,0,0,1,.262-2.226c.21-1.363.5-3.245.772-5.331s.472-3.978.617-5.35a10.97,10.97,0,0,1,.317-2.22",
    transform: "translate(-19.571 -21.81)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5679",
    "data-name": "Path 5679",
    d: "M181.87,139.209c.023.019-.113.232-.389.594a12.6,12.6,0,0,1-1.284,1.449,6.149,6.149,0,0,1-2.485,1.506,6.81,6.81,0,0,1-3.558-.034,14.655,14.655,0,0,1-5.618-3.006,12.766,12.766,0,0,1-1.375-1.361c-.3-.346-.436-.558-.415-.577.056-.05.724.7,1.991,1.691a16.037,16.037,0,0,0,5.526,2.814,6.622,6.622,0,0,0,3.335.072,6.174,6.174,0,0,0,2.384-1.343c1.19-1.065,1.825-1.861,1.887-1.8",
    transform: "translate(-21.742 -17.965)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferFriend);
export default __webpack_public_path__ + "static/media/refer-friend.6cd96c344b4c92dc915f3f2e76e90a6f.svg";
export { ForwardRef as ReactComponent };